import { render, staticRenderFns } from "./EventTicketGroupForm.vue?vue&type=template&id=70c8c6b9&scoped=true&"
import script from "./EventTicketGroupForm.vue?vue&type=script&lang=js&"
export * from "./EventTicketGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./EventTicketGroupForm.vue?vue&type=style&index=0&id=70c8c6b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8c6b9",
  null
  
)

export default component.exports